/**
 * assets/amplitude-analytics.js
 * Gedrag van snippets/amplitude-analytics.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  'use strict';

  /* Config en server-side paginacontext komen uit het JSON-eiland
     #amplitude-config hierboven. Zie ARCHITECTURE.md sectie 11. */
  var CONFIG = {};
  try {
    var _cfgEl = document.getElementById('amplitude-config');
    if (_cfgEl) CONFIG = JSON.parse(_cfgEl.textContent) || {};
  } catch (_e) { CONFIG = {}; }
  if (!CONFIG.apiKey) return;

  var API_KEY = CONFIG.apiKey;
  var SERVER_ZONE = 'EU';
  /* Identiteit: user_id alleen bij ingelogde klant, formaat gelijk aan de worker
     (shopify_customer_<id>). NOOIT e-mail/telefoon. Anoniem = geen user_id. */
  var USER_ID = CONFIG.userId || null;
  /* SDK + Session Replay-plugin via CDN (Amplitude Browser SDK 2). */
  var AMP_SDK_URL = 'https://cdn.amplitude.com/libs/analytics-browser-2.44.5-min.js.gz';
  var SR_PLUGIN_URL = 'https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.33.1-min.js.gz';
  /* Session Replay inschakelbaar + conservatieve sample rate (percentage 0-100).
     Masking en sample rate staan OOK in de EU-projectinstellingen (remote wint). */
  var REPLAY_ENABLED = !!CONFIG.replayEnabled;
  var REPLAY_SAMPLE_RATE = (Number(CONFIG.replaySampleRate) || 10) / 100;
  /* Versie-context (server-side bekend, geen gok): attributie- en schemaversie
     + thema-release. Meegestuurd op tool-events en cart-attributie. */
  var ATTRIBUTION_VERSION = 'v2';
  var SCHEMA_VERSION = '2026-07-16';
  var THEME_RELEASE = CONFIG.themeRelease || '';
  var loaded = false;
  var started = false;
  var preConsentPageEvents = [];

  function tpl() {
    try { return (document.body && document.body.getAttribute('data-template')) || ''; } catch (_) { return ''; }
  }

  /* --- Consent: identiek patroon als VijverCheck/Clarity + GPC --- */
  function hasAnalyticsConsent() {
    try { if (navigator.globalPrivacyControl === true) return false; } catch (_) {}
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return !!cp.analyticsProcessingAllowed();
      }
      if (cp && typeof cp.currentVisitorConsent === 'function') {
        return cp.currentVisitorConsent().analytics === 'yes';
      }
    } catch (_) {}
    return false;
  }

  /* --- Publieke, veilige track-API (buffert tot SDK klaar is) --- */
  var _queue = [];
  function track(name, props) {
    if (!name) return;
    var payload = props || {};
    if (started && window.amplitude && typeof window.amplitude.track === 'function') {
      try { window.amplitude.track(name, payload); } catch (_) {}
    } else {
      _queue.push([name, payload]);
      if (_queue.length > 200) _queue.shift();
    }
  }
  window.vcAmplitude = { track: track, isReady: function () { return started; }, lineItemProps: lineItemProps };

  /* --- SDK laden (alleen na consent) --- */
  function loadScript(src, onload, onerror) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    s.onload = onload;
    s.onerror = onerror || function () {};
    document.head.appendChild(s);
  }
  function loadAmplitude() {
    if (loaded) return;
    loaded = true;
    /* Core SDK moet laden; de Session Replay-plugin is best-effort. init draait
       na de plugin-laadpoging (geslaagd of niet), zodat de plugin VOOR init wordt
       toegevoegd wanneer beschikbaar. */
    loadScript(AMP_SDK_URL, function () {
      if (REPLAY_ENABLED) {
        loadScript(SR_PLUGIN_URL, initAmplitude, initAmplitude);
      } else {
        initAmplitude();
      }
    }, function () { loaded = false; });
  }

  /* --- Identiteits-unificatie met de worker: device_id = 'ga_' + GA client_id --- */
  /* De worker-fan-out zet device_id = 'ga_<cid>' uit het _ga cookie (formaat
     GA1.1.<cid1>.<cid2> -> cid = '<cid1>.<cid2>'). Zo delen worker (commerce) en
     deze SDK (tools/replay) dezelfde bezoeker. Ontbreekt het cookie, dan laat de
     SDK zelf een device_id genereren (fallback). */
  function getGaClientId() {
    try {
      var m = (document.cookie || '').match(/(?:^|;\s*)_ga=([^;]+)/);
      if (!m) return null;
      var parts = decodeURIComponent(m[1]).split('.');
      /* GA1.1.<cid1>.<cid2> -> laatste twee segmenten vormen de client_id */
      if (parts.length >= 4) return parts[parts.length - 2] + '.' + parts[parts.length - 1];
      return null;
    } catch (_) { return null; }
  }
  function waitForGaClientId(cb) {
    var tries = 0, max = 20; /* ~2s (20 x 100ms), dan fallback op SDK-device_id */
    (function attempt() {
      var cid = getGaClientId();
      if (cid) { cb('ga_' + cid); return; }
      if (++tries >= max) { cb(null); return; }
      setTimeout(attempt, 100);
    })();
  }

  var initInvoked = false;
  function initAmplitude() {
    if (initInvoked || started || !window.amplitude) return;
    initInvoked = true;
    /* device_id VOOR de eerste events vaststellen (kort pollen op het _ga cookie) */
    waitForGaClientId(function (deviceId) {
      try {
        var opts = {
          serverZone: SERVER_ZONE,
          /* Pseudoniem: geen IP-opslag */
          trackingOptions: { ipAddress: false },
          /* Autocapture: sessies + form-INTERACTIES (metadata, geen veldwaarden)
             + file-downloads + element/click-interacties. pageViews UIT: die
             stuurt de worker (page_viewed). GEEN commerce-events vanuit de SDK. */
          autocapture: {
            attribution: true,
            pageViews: false,
            sessions: true,
            formInteractions: true,
            fileDownloads: true,
            elementInteractions: true,
            /* frustrationInteractions: rage-, dead- en error-clicks + thrashed cursor.
               Vervangt Microsoft Clarity, dat via de export-API onbruikbaar bleek
               (willekeurige doorsnede van 25 URLs i.p.v. top-N, 1 dag i.p.v. 3,
               geen URL-normalisatie). Zie memory design-shopify-kaizen-log 01-08-2026. */
            frustrationInteractions: true
          }
        };
        /* Gedeeld device_id met de worker; anders SDK-fallback (optie weglaten) */
        if (deviceId) opts.deviceId = deviceId;

        /* Session Replay-plugin VOOR init toevoegen (alleen na consent = hier).
           Strenge masking (alle inputs/tekst) + conservatieve sampleRate; deze
           staan OOK in de EU-projectinstellingen (remote config wint). */
        if (REPLAY_ENABLED && window.sessionReplay && typeof window.sessionReplay.plugin === 'function') {
          try {
            window.amplitude.add(window.sessionReplay.plugin({
              sampleRate: REPLAY_SAMPLE_RATE,
              serverZone: SERVER_ZONE,
              privacyConfig: { defaultMaskLevel: 'conservative' }
            }));
          } catch (_) {}
        }

        window.amplitude.init(API_KEY, USER_ID || undefined, opts);
        started = true;
        /* buffer legen */
        var q = _queue.splice(0, _queue.length);
        q.forEach(function (e) { try { window.amplitude.track(e[0], e[1]); } catch (_) {} });
        preConsentPageEvents.splice(0).forEach(function (e) { track(e[0], e[1]); });
        bindDataLayerBridge();
        bindDomHooks();
      } catch (_) { started = false; }
    });
  }

  /* --- dataLayer-bridge: map bestaande events -> canonieke Amplitude-namen --- */
  /* Ontdubbeld met de worker-fan-out (data.vijvercentrum.nl, LIVE): de
     commerce-funnel (product_viewed, collection_viewed, add_to_cart,
     checkout_started, order_completed) + attributie worden AL door de worker
     gestuurd (device_id = 'ga_<cid>'). Deze snippet stuurt die events bewust
     NIET, om dubbeltracking te voorkomen. Alleen site-eigen zoek-, filter-,
     content-, tool- en assistent-events + VijverCheck komen van deze SDK. */
  var EVENT_MAP = {
    /* GA4 custom (snippets/ga4-*.liquid) - uniek, niet-commerce */
    search_zero_results:  'search_no_results',
    search_synonym_match: 'search_synonym_used',
    free_shipping_reached:'free_shipping_reached',
    bundle_add_to_cart:   'bundle_add_to_cart',
    sticky_cta_click:     'sticky_cta_clicked',
    /* VijverCheck (assets/vijvercheck-v2.js, vw_* namespace) */
    vw_advice_requested:  'vijvercheck_started',
    vw_advice_viewed:     'vijvercheck_completed',
    vw_advice_error:      'vijvercheck_error',
    vw_volume_calculated: 'calculator_used',
    vw_product_click:     'vijvercheck_product_clicked',
    vw_collection_click:  'vijvercheck_collection_clicked',
    vw_equipment_click:   'vijvercheck_equipment_clicked',
    vw_vet_cta_click:     'vijvercheck_vet_cta_clicked',
    vw_add_to_cart:       'recommendation_added_to_cart',
    /* Mijn Vijverprofiel (sections/mijn-vijverprofiel.liquid, gtag) */
    mijn_vijver_step:     'profile_step_completed',
    /* Afrekenen (assets/av-akkoord-popup.js, project Design en UX 2027).
       Gaan als gtag-event naar GA4. Deze regels tellen alleen als de SDK hier
       weer aan gaat (settings.amplitude_enabled, uit sinds 14-10-2026); ze
       staan bewust NIET in de worker-map, anders telt Amplitude dubbel. */
    av_akkoord_klik_zonder_vinkje: 'av_akkoord_klik_zonder_vinkje',
    av_akkoord_aangevinkt:         'av_akkoord_aangevinkt',
    av_akkoord_doorgestuurd:       'av_akkoord_doorgestuurd',
    av_akkoord_terug_uit_checkout: 'av_akkoord_terug_uit_checkout',
    /* Winkelwagen (snippets/winkelwagen-eerste-aanmaak.liquid) */
    winkelwagen_aanmaak_gewacht:   'winkelwagen_aanmaak_gewacht'
  };

  /* Meetpunten die al in de eerste seconden van een pagina vallen, vaak voordat
     Amplitude geladen is (na de consent). Die geeft bindDataLayerBridge alsnog
     door uit de dataLayer van DEZE pagina. Alleen deze namen, zodat de
     tellingen van de bestaande events niet veranderen. */
  var NA_TE_LEVEREN = {
    av_akkoord_klik_zonder_vinkje: 1,
    av_akkoord_aangevinkt: 1,
    av_akkoord_terug_uit_checkout: 1,
    winkelwagen_aanmaak_gewacht: 1
  };

  /* Alleen niet-PII property-sleutels doorlaten */
  var PII_KEYS = { email: 1, e_mail: 1, naam: 1, name: 1, phone: 1, telefoon: 1,
    address: 1, adres: 1, postcode: 1, zip: 1, lat: 1, lng: 1, latitude: 1, longitude: 1,
    huisnummer: 1, straat: 1, plaats: 1, woonplaats: 1, gemeente: 1, city: 1, ip: 1,
    query: 1, question: 1, vraag: 1, message: 1, bericht: 1, chat: 1, prompt: 1,
    text: 1, tekst: 1, answer_text: 1, coordinates: 1 };

  /* Waarde-scrub: redact e-mail, telefoon en lange cijferreeksen uit vrije tekst */
  function scrubText(s) {
    try {
      return String(s)
        .replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, '[email]')
        .replace(/\+?\d[\d\s().-]{6,}\d/g, '[num]');
    } catch (_) { return ''; }
  }
  function scrub(props) {
    var out = {};
    if (!props || typeof props !== 'object') return out;
    Object.keys(props).forEach(function (k) {
      if (PII_KEYS[String(k).toLowerCase()]) return;
      var v = props[k];
      if (v == null) return;
      if (typeof v === 'object') return; /* geen geneste PII */
      if (typeof v === 'string') v = scrubText(v).slice(0, 200);
      out[k] = v;
    });
    return out;
  }

  /* --- Tool-context: tool_session_id per tool-sessie --- */
  var TOOL_KEY = 'vc_tool_session';
  function currentToolName() {
    var t = tpl(), p = '';
    try { p = location.pathname || ''; } catch (_) {}
    if (/vijvercheck/.test(t) || /vijvercheck/.test(p)) return 'vijvercheck';
    if (/mijn-vijverprofiel|vijverprofiel/.test(t) || /mijn-vijverprofiel/.test(p)) return 'vijverprofiel';
    if (/calculator|vijverpomp-gids|uv-c-lamp-kiezen|vijveradviseur/.test(t)) return 'calculator';
    return '';
  }
  function genId() {
    try {
      if (window.crypto && crypto.randomUUID) return 'vc_' + crypto.randomUUID();
    } catch (_) {}
    return 'vc_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }
  function getToolContext() {
    var tool = currentToolName();
    if (!tool) return null;
    var rec = null;
    try { rec = JSON.parse(sessionStorage.getItem(TOOL_KEY) || 'null'); } catch (_) {}
    if (!rec || rec.tool !== tool || !rec.id) {
      rec = { tool: tool, id: genId(), ts: Date.now() };
      try { sessionStorage.setItem(TOOL_KEY, JSON.stringify(rec)); } catch (_) {}
    }
    /* Cartniveau = alleen de PRIMAIRE (eerste) toolsessie als globale context.
       Nooit blind overschrijven bij een latere aanbeveling (geen last-write-wins). */
    writePrimaryCartContext(rec.id);
    return { tool_name: tool, tool_session_id: rec.id };
  }
  function adviceVersion() {
    try { var el = document.querySelector('[data-advice-version]'); if (el) return el.getAttribute('data-advice-version'); } catch (_) {}
    return null;
  }
  function isToolEvent(name) {
    return /^(vijvercheck_|vijverprofiel_|profile_|calculator_|recommendation_|advice_|tool_|keuzehulp_|quiz_)/.test(name);
  }
  function trackTool(name, props) {
    var p = scrub(props || {});
    var ctx = getToolContext();
    if (ctx) { if (p.tool_name == null) p.tool_name = ctx.tool_name; p.tool_session_id = ctx.tool_session_id; }
    /* Versie-properties op tool-events (eenvoudig, server-side bekend) */
    if (p.schema_version == null) p.schema_version = SCHEMA_VERSION;
    if (p.attribution_version == null) p.attribution_version = ATTRIBUTION_VERSION;
    if (p.release_version == null) p.release_version = THEME_RELEASE;
    track(name, p);
  }

  /* --- Cart-attributen: geeft de order server-side de tool-context --- */
  /* Defensief: faalt stil als de cart-API niet reageert. Dedupe op waarde. */
  var _cartWritten = {};
  function writeCartAttributes(attrs) {
    try {
      if (!attrs) return;
      var body = { attributes: {} };
      var any = false;
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v == null || v === '') return;
        v = String(v);
        if (_cartWritten[k] === v) return;
        body.attributes[k] = v;
        _cartWritten[k] = v;
        any = true;
      });
      if (!any) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function () {});
    } catch (_) {}
  }

  /* --- Cartniveau: primaire toolsessie als globale context (dubbele underscore) --- */
  /* Shopify-conventie: dubbele underscore = private CART attribute. We schrijven
     ALLEEN de eerste toolsessie weg en overschrijven die nooit bij een latere
     aanbeveling (voorkomt last-write-wins op de hele order). Defensief: faalt stil. */
  var PRIMARY_KEY = 'vc_primary_tool_session';
  function writePrimaryCartContext(sessionId) {
    if (!sessionId) return;
    try {
      var existing = null;
      try { existing = sessionStorage.getItem(PRIMARY_KEY); } catch (_) {}
      if (existing) return; /* primaire sessie al vastgelegd: niet overschrijven */
      try { sessionStorage.setItem(PRIMARY_KEY, sessionId); } catch (_) {}
      writeCartAttributes({
        __vc_primary_tool_session_id: sessionId,
        __vc_attribution_version: ATTRIBUTION_VERSION
      });
    } catch (_) {}
  }

  /* --- Line-item-attributie: herkomst per product (enkele underscore) --- */
  /* Shopify-conventie: enkele underscore = private LINE-ITEM property. Deze horen
     op de add-to-cart-payload (properties[...] in de POST naar /cart/add.js), NIET
     op cartniveau. De snippet bezit die add-to-cart niet; secties leveren de
     context aan via deze helper en mergen de return-waarde in body.properties.

     SECTIE-CONTRACT (nog te implementeren in de secties):
       assets/vijvercheck-v2.js -> vwAtcFromCrossSell, de POST naar /cart/add.js:
         body: JSON.stringify({ id: Number(variantId), quantity: 1,
           properties: window.vcAmplitude.lineItemProps({
             rule_id: btn.getAttribute('data-rule-id'),
             recommendation_id: btn.getAttribute('data-recommendation-id'),
             recommendation_rank: btn.getAttribute('data-recommendation-rank'),
             advice_version: btn.getAttribute('data-advice-version')
           }) })
     Vereiste NIEUWE data-attributen op de advies-/cross-sell-knop
     ([data-vw-prod-atc]) die vandaag ONTBREKEN:
       - data-recommendation-id   (stabiele id van de aanbeveling; nu afwezig)
       - data-recommendation-rank (positie in de adviesreeks; nu afwezig)
       - data-advice-version      (versie van de adviesregels; nu afwezig,
                                    adviceVersion() vindt vandaag niets)
     data-rule-id en data-product-id bestaan al. De Doofinder-assistent en de
     collectie-popup add-to-cart hebben een eigen, vergelijkbare hook nodig als
     hun herkomst ook per orderregel mee moet. Zolang de attributen ontbreken
     levert lineItemProps alleen _vc_tool_session_id (en waar beschikbaar
     _vc_rule_id) op; dat is correct en veilig (geen gok). */
  function lineItemProps(opts) {
    opts = opts || {};
    var out = {};
    try {
      var ctx = getToolContext();
      var sid = opts.tool_session_id || (ctx && ctx.tool_session_id) || null;
      if (sid) out._vc_tool_session_id = String(sid);
      if (opts.recommendation_id) out._vc_recommendation_id = String(opts.recommendation_id);
      if (opts.rule_id) out._vc_rule_id = String(opts.rule_id);
      if (opts.recommendation_rank != null && opts.recommendation_rank !== '') out._vc_recommendation_rank = String(opts.recommendation_rank);
      var av = opts.advice_version || adviceVersion();
      if (av) out._vc_advice_version = String(av);
    } catch (_) {}
    return out;
  }

  function bridgeEvent(name, props) {
    var canonical = EVENT_MAP[name];
    if (!canonical) return;
    var mapped = scrub(props);
    if (canonical === 'calculator_used') mapped.calculator = mapped.calculator || 'vijvervolume';
    if (canonical === 'profile_step_completed') {
      mapped = { step: (props && props.step) || null, field: (props && props.field) || null };
    }
    if (isToolEvent(canonical)) trackTool(canonical, mapped);
    else track(canonical, mapped);

    /* Afgeleide recommendation-events (VijverCheck-advies).
       LET OP: geen cart-attributen op cartniveau meer. Adviesherkomst hoort per
       orderregel (line-item properties via de add-to-cart-payload), niet globaal
       op de cart. Zie window.vcAmplitude.lineItemProps + het SECTIE-CONTRACT. */
    if (name === 'vw_product_click') {
      var recId = (props && (props.recommendation_id || props.rec_id)) || null;
      var ruleId = (props && props.rule_id) || null;
      trackTool('recommendation_clicked', {
        recommendation_id: recId,
        rule_id: ruleId,
        recommendation_rank: (props && (props.recommendation_rank || props.rank || props.position)) || null,
        tool_name: 'vijvercheck',
        recommendation_type: 'product',
        product_id: (props && (props.product_id || props.handle || props.id)) || null
      });
    }
  }

  function bindDataLayerBridge() {
    try {
      window.dataLayer = window.dataLayer || [];
      for (var j = 0; j < window.dataLayer.length; j++) {
        var eerder = window.dataLayer[j];
        if (eerder && eerder['0'] === 'event' && NA_TE_LEVEREN[eerder['1']]) bridgeEvent(eerder['1'], eerder['2']);
        else if (eerder && typeof eerder.event === 'string' && NA_TE_LEVEREN[eerder.event]) bridgeEvent(eerder.event, eerder);
      }
      var origPush = window.dataLayer.push.bind(window.dataLayer);
      window.dataLayer.push = function () {
        for (var i = 0; i < arguments.length; i++) {
          var a = arguments[i];
          /* gtag('event', name, params) -> arguments-object ['event', name, params] */
          if (a && a['0'] === 'event' && typeof a['1'] === 'string') {
            bridgeEvent(a['1'], a['2']);
          } else if (a && a.event && typeof a.event === 'string') {
            bridgeEvent(a.event, a);
          }
        }
        return origPush.apply(null, arguments);
      };
    } catch (_) {}
  }

  /* --- Canonieke page-events, server-side gevuld uit Liquid --- */
  /* product_viewed en collection_viewed komen van de worker-fan-out;
     hier bewust weggelaten (geen commerce-events vanuit de SDK). */

  /* De server-side gevulde events staan in het JSON-eiland onder pageEvents,
     als [naam, props]-paren. Nu alleen search_performed; nieuwe events voeg je
     daar toe, niet hier. */
  if (Array.isArray(CONFIG.pageEvents)) {
    for (var _pe = 0; _pe < CONFIG.pageEvents.length; _pe++) {
      preConsentPageEvents.push(CONFIG.pageEvents[_pe]);
    }
  }

  /* --- Extra DOM-hooks, defensief en self-contained --- */
  function bindDomHooks() {
    var d = document;

    /* filter_used: PLP-filterinputs (data-filter-input[-mobile]) */
    d.addEventListener('change', function (e) {
      var el = e.target;
      if (!el) return;
      if (el.matches && el.matches('[data-filter-input], [data-filter-input-mobile]')) {
        track('filter_used', {
          filter_name: el.name || el.dataset.filterName || 'onbekend',
          filter_value: (el.type === 'checkbox') ? (el.checked ? el.value : '(uit)') : el.value,
          template: tpl()
        });
      }
    }, { passive: true });

    /* shipping_info_opened: verzend-links/tabs */
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="verzend"], a[href*="verzending"], [data-shipping-info]');
      if (a) {
        track('shipping_info_opened', {
          source: a.getAttribute('href') || a.dataset.shippingInfo || 'tab',
          template: tpl()
        });
      }
    }, { passive: true });

    /* reviews_read: reviews-sectie 50% in beeld */
    var reviewEls = d.querySelectorAll('[data-reviews], #product-reviews, .product-reviews, [data-open-sheet="reviews"]');
    if (reviewEls.length && 'IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            track('reviews_read', { template: tpl() });
            ro.unobserve(en.target);
          }
        });
      }, { threshold: 0.5 });
      reviewEls.forEach(function (el) { ro.observe(el); });
    }

    /* keuzehulp_opened + calculator_used: keuzehulp/gids-pagina's */
    var tplName = tpl();
    if (/uv-c-lamp-kiezen|vijverpomp-gids|vijveradviseur|calculator/.test(tplName)) {
      trackTool('keuzehulp_opened', { keuzehulp: tplName });
    }
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-keuzehulp-step], [data-keuzehulp-result], [data-calculator-submit]');
      if (b) {
        trackTool('calculator_used', {
          calculator: b.dataset.calculator || tplName || 'keuzehulp',
          step: b.dataset.keuzehulpStep || null,
          has_result: b.hasAttribute('data-keuzehulp-result')
        });
      }
    }, { passive: true });

    /* quiz_started / quiz_completed: vijveradviseur-quiz (data-quiz-*) */
    d.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-quiz-start]');
      if (q) trackTool('quiz_started', { quiz: q.dataset.quizStart || 'vijveradviseur' });
    }, { passive: true });
    d.addEventListener('quiz:completed', function (e) {
      trackTool('quiz_completed', scrub((e && e.detail) || {}));
    });

    /* v2-modules */
    if (currentToolName() === 'vijvercheck') observeRecommendations();
    initContentHooks();
    initProfiel();
    initAssistant();
    initReliability();
  }

  /* --- recommendation_viewed: advies-cards/producten in beeld --- */
  function observeRecommendations() {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var rid = el.getAttribute('data-recommendation-id') || '';
        var rule = el.getAttribute('data-rule-id') || '';
        var pid = el.getAttribute('data-product-id') || el.getAttribute('data-product-handle') || '';
        var key = rule + '|' + pid;
        if (seen[key]) { io.unobserve(el); return; }
        seen[key] = 1;
        var rank = el.getAttribute('data-recommendation-rank');
        if (rank == null) {
          try {
            var sibs = el.parentNode ? Array.prototype.slice.call(el.parentNode.querySelectorAll('[data-rule-id], [data-vw-prod-atc]')) : [];
            var idx = sibs.indexOf(el);
            rank = idx >= 0 ? (idx + 1) : null;
          } catch (_) { rank = null; }
        }
        trackTool('recommendation_viewed', {
          recommendation_id: rid || null,
          rule_id: rule || null,
          recommendation_rank: rank != null ? parseInt(rank, 10) : null,
          tool_name: 'vijvercheck',
          recommendation_type: 'product',
          product_id: pid || null
        });
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    function scan() {
      try {
        var els = document.querySelectorAll('[data-vw-prod-atc], [data-rule-id]');
        Array.prototype.forEach.call(els, function (el) { io.observe(el); });
      } catch (_) {}
    }
    scan();
    try {
      var mo = new MutationObserver(function () { scan(); });
      var container = document.querySelector('[data-vc="vijvercheck"]') || document.querySelector('main') || document.body;
      mo.observe(container, { childList: true, subtree: true });
    } catch (_) {}
  }

  /* --- content_interaction + content_viewed/content_engaged --- */
  var _ciLast = {};
  function contentInteraction(type, extra) {
    var now = Date.now();
    if (_ciLast[type] && (now - _ciLast[type]) < 700) return;
    _ciLast[type] = now;
    track('content_interaction', scrub(Object.assign({ interaction_type: type, template: tpl() }, extra || {})));
  }
  function baseName(u) {
    try { return String(u || '').split('?')[0].split('#')[0].split('/').pop() || ''; } catch (_) { return ''; }
  }
  function initContentHooks() {
    var d = document;

    /* <details> accordions -> faq_opened bij openen */
    d.addEventListener('toggle', function (e) {
      var el = e.target;
      if (el && el.tagName === 'DETAILS' && el.open) contentInteraction('faq_opened', { source: 'details' });
    }, true);

    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var m;
      if ((m = t.closest('.mv-faq-q, [data-faq-q], [data-faq], .faq__question, [data-accordion-trigger]'))) {
        contentInteraction('faq_opened', { source: 'accordion' });
      } else if ((m = t.closest('[data-tab="specificaties"], [data-tab="specificatie"], [data-spec-toggle], [data-open-sheet="specs"], [data-open-sheet="specificaties"], a[href*="specificat"]'))) {
        contentInteraction('specification_opened', {});
      } else if ((m = t.closest('a[href$=".pdf"], a[href*="handleiding"], a[download][href]'))) {
        contentInteraction('manual_downloaded', { file: baseName(m.getAttribute('href')) });
      } else if ((m = t.closest('[data-compatibility], [data-open-sheet="compatibility"], [data-tab="compatibiliteit"], a[href*="compatib"]'))) {
        contentInteraction('compatibility_opened', {});
      } else if ((m = t.closest('[data-video-play], .js-video, [data-video]'))) {
        contentInteraction('video_started', { source: 'embed' });
      }
    }, { passive: true });

    /* echte <video> play -> video_started */
    d.addEventListener('play', function (e) {
      var el = e.target;
      if (el && el.tagName === 'VIDEO') contentInteraction('video_started', { source: 'video' });
    }, true);

    /* content_viewed / content_engaged: kennis-/artikelpagina's */
    var t = tpl();
    if (/article|blog|kennis|gids|vijverkennis/.test(t)) {
      track('content_viewed', { template: t, content_type: 'article' });
      var engaged = false, deep = false, dwell = false;
      function maybeEngage() {
        if (engaged || !deep || !dwell) return;
        engaged = true;
        track('content_engaged', { template: t, engagement_type: 'meaningful_read' });
      }
      setTimeout(function () { dwell = true; maybeEngage(); }, 30000);
      var onScroll = function () {
        try {
          var h = document.documentElement;
          var pct = (h.scrollTop + window.innerHeight) / (h.scrollHeight || 1);
          if (pct >= 0.5) { deep = true; maybeEngage(); window.removeEventListener('scroll', onScroll); }
        } catch (_) {}
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* --- Vijverprofiel: funnel + save-failure --- */
  function initProfiel() {
    if (currentToolName() !== 'vijverprofiel') return;
    var app = document.getElementById('mvApp');
    if (!app) return;
    trackTool('profile_started', {});

    function loggedIn() {
      try {
        if (document.body.classList.contains('customer-logged-in')) return true;
        if (window.__st && window.__st.cid) return true;
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) return true;
      } catch (_) {}
      return false;
    }
    function storageAvailable() {
      try { var k = '__vc_probe'; localStorage.setItem(k, '1'); localStorage.removeItem(k); return true; } catch (_) { return false; }
    }

    var loading = document.getElementById('mvLoading');
    var result = document.getElementById('mvResult');
    var errEl = document.getElementById('mvError');
    var attempted = false, resolved = false;
    function shown(el) { return el && !el.classList.contains('mv-hidden'); }
    function onAttempt() {
      if (attempted) return;
      attempted = true;
      trackTool('profile_save_attempted', { stage: 'save', logged_in: loggedIn(), storage_available: storageAvailable() });
    }
    function onSuccess() {
      if (resolved) return;
      resolved = true;
      trackTool('profile_save_succeeded', { stage: 'save', logged_in: loggedIn() });
    }
    function onFail() {
      if (resolved) return;
      resolved = true;
      var online = (typeof navigator.onLine === 'boolean') ? navigator.onLine : true;
      var requestBlocked = true; /* het error-scherm verschijnt alleen als de awaited save niet bevestigd is */
      /* ad_block_suspected alleen bij technisch signaal: online maar eigen endpoint niet bevestigd */
      var adBlock = online && requestBlocked;
      trackTool('profile_save_failed', {
        stage: 'save',
        error_code: 'save_unconfirmed',
        http_status: null,
        storage_available: storageAvailable(),
        request_blocked: requestBlocked,
        ad_block_suspected: adBlock,
        retry_count: 0,
        logged_in: loggedIn()
      });
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (shown(loading)) onAttempt();
        if (shown(result)) { onAttempt(); onSuccess(); }
        if (shown(errEl)) { onAttempt(); onFail(); }
      });
      [loading, result, errEl].forEach(function (el) { if (el) mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
    }
  }

  /* --- Vijverhulp-assistent (Doofinder AI) --- */
  /* Alleen gecontroleerde labels; NOOIT de vraagtekst zelf. Deels afhankelijk
     van door de integratie te leveren data-attributen / custom events. */
  function initAssistant() {
    var d = document;
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-df-ai-open]');
      if (b) track('assistant_started', { entry_point: b.getAttribute('data-df-entry') || tpl(), page_type: tpl() });
    }, { passive: true });

    /* Doofinder cart-add vanuit de assistent */
    d.addEventListener('doofinder.cart.add', function (e) {
      var det = (e && e.detail) || {};
      track('assistant_product_clicked', scrub({ product_id: det.item_id || det.id || null, recommendation_rank: det.index != null ? det.index : null }));
    });

    /* Gecontroleerde DOM-hooks (data-attributen) */
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var s;
      if ((s = t.closest('[data-assistant-source]'))) {
        track('answer_source_clicked', scrub({ source_id: s.getAttribute('data-assistant-source') || null, content_id: s.getAttribute('data-content-id') || null }));
      } else if ((s = t.closest('[data-assistant-product]'))) {
        track('assistant_product_clicked', scrub({ product_id: s.getAttribute('data-assistant-product') || null, recommendation_rank: s.getAttribute('data-recommendation-rank') || null }));
      } else if ((s = t.closest('[data-assistant-feedback]'))) {
        track('assistant_feedback_submitted', scrub({ feedback: s.getAttribute('data-assistant-feedback') || null, reason: s.getAttribute('data-feedback-reason') || null }));
      } else if ((s = t.closest('[data-assistant-escalate]'))) {
        track('assistant_escalated', scrub({ channel: s.getAttribute('data-assistant-escalate') || null }));
      }
    }, { passive: true });

    /* Custom events die de assistent-integratie kan dispatchen (labels, geen tekst) */
    d.addEventListener('assistant:question', function (e) {
      var det = (e && e.detail) || {};
      track('question_submitted', scrub({ intent: det.intent || null, topic: det.topic || null, subtopic: det.subtopic || null, urgency: det.urgency || null }));
    });
    d.addEventListener('assistant:answer', function (e) {
      var det = (e && e.detail) || {};
      track('answer_shown', scrub({ answer_id: det.answer_id || null, model_version: det.model_version || null, knowledge_version: det.knowledge_version || null, source_count: det.source_count != null ? det.source_count : null }));
    });
    d.addEventListener('assistant:error', function (e) {
      var det = (e && e.detail) || {};
      track('assistant_error', scrub({ error_code: det.error_code || null, stage: det.stage || null }));
    });
  }

  /* --- Betrouwbaarheid (licht, native, geen zware afhankelijkheden) --- */
  function initReliability() {
    var errCount = 0;
    /* Ruisfilter: opake cross-origin 'Script error.' en resource-/event-ruis zijn niet herleidbaar; alleen echte, herleidbare fouten doorlaten. */
    function isNoise(m) {
      if (!m) return true;
      if (m === 'Script error.' || m === 'Script error') return true;
      if (m === '[object Object]') return true;
      if (/^\[object [A-Za-z]*Event\]$/.test(m)) return true;
      return false;
    }
    function reportErr(msg, src, line, type) {
      if (errCount >= 8) return;
      var m = String(msg == null ? '' : msg);
      if (isNoise(m)) return;
      errCount++;
      track('client_error', {
        error_type: type || 'error',
        error_message: scrubText(m).slice(0, 140),
        error_source: baseName(src),
        error_line: line || null,
        template: tpl()
      });
    }
    window.addEventListener('error', function (e) {
      try {
        /* Resource-load fouten (img/script/link) hebben geen echte message: overslaan */
        if (e && e.target && e.target !== window && e.target.tagName) return;
        reportErr(e.message, e.filename, e.lineno, (e.error && e.error.name) || 'error');
      } catch (_) {}
    });
    window.addEventListener('unhandledrejection', function (e) {
      try { var r = e.reason; reportErr((r && r.message) || r, '', null, 'unhandledrejection'); } catch (_) {}
    });

    initWebVitals();
    initFrustration();
  }

  function initWebVitals() {
    if (!('PerformanceObserver' in window)) return;
    var lcp = 0, cls = 0, inp = 0, reported = false;
    try {
      var poL = new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { lcp = en.startTime; }); });
      poL.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (_) {}
    try {
      var poC = new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { if (!en.hadRecentInput) cls += en.value; }); });
      poC.observe({ type: 'layout-shift', buffered: true });
    } catch (_) {}
    try {
      var poE = new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { var dd = en.duration || 0; if (dd > inp) inp = dd; }); });
      poE.observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (_) {}
    function rate(name, v) {
      if (name === 'LCP') return v <= 2500 ? 'good' : (v <= 4000 ? 'needs_improvement' : 'poor');
      if (name === 'INP') return v <= 200 ? 'good' : (v <= 500 ? 'needs_improvement' : 'poor');
      if (name === 'CLS') return v <= 0.1 ? 'good' : (v <= 0.25 ? 'needs_improvement' : 'poor');
      return null;
    }
    function flush() {
      if (reported) return;
      reported = true;
      if (lcp > 0) track('web_vital_observed', { metric_name: 'LCP', metric_value: Math.round(lcp), metric_rating: rate('LCP', lcp), template: tpl() });
      track('web_vital_observed', { metric_name: 'CLS', metric_value: Math.round(cls * 1000) / 1000, metric_rating: rate('CLS', cls), template: tpl() });
      if (inp > 0) track('web_vital_observed', { metric_name: 'INP', metric_value: Math.round(inp), metric_rating: rate('INP', inp), template: tpl() });
    }
    window.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
    window.addEventListener('pagehide', flush);
  }

  function tagOf(el) {
    try {
      if (!el || !el.tagName) return '';
      return el.tagName.toLowerCase() + (el.id ? ('#' + el.id) : '');
    } catch (_) { return ''; }
  }
  function initFrustration() {
    var clicks = [];
    var lastFrust = 0;
    var lastMutation = Date.now();
    try {
      var mo = new MutationObserver(function () { lastMutation = Date.now(); });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true });
    } catch (_) {}
    document.addEventListener('click', function (e) {
      var now = Date.now();
      clicks.push({ x: e.clientX, y: e.clientY, t: now });
      clicks = clicks.filter(function (c) { return (now - c.t) < 1000; });
      var near = clicks.filter(function (c) { return Math.abs(c.x - e.clientX) < 40 && Math.abs(c.y - e.clientY) < 40; });
      if (near.length >= 4 && (now - lastFrust) > 2000) {
        lastFrust = now;
        track('frustration_detected', { signal: 'rage_click', template: tpl(), element: tagOf(e.target) });
        return;
      }
      var t = e.target;
      if (t && t.closest && !t.closest('a, button, input, select, textarea, label, [role=button], [onclick], [data-df-ai-open], summary, details')) {
        var beforeUrl = '';
        try { beforeUrl = location.href; } catch (_) {}
        var atClick = now;
        setTimeout(function () {
          try {
            if ((Date.now() - lastFrust) <= 2000) return;
            if (location.href !== beforeUrl) return;
            if (lastMutation > atClick) return;
            lastFrust = Date.now();
            track('frustration_detected', { signal: 'dead_click', template: tpl(), element: tagOf(t) });
          } catch (_) {}
        }, 700);
      }
    }, true);
  }

  /* --- Boot: consent nu, of luister op consent-collect --- */
  function boot() {
    if (hasAnalyticsConsent()) { loadAmplitude(); return; }
  }
  document.addEventListener('visitorConsentCollected', function (e) {
    if (e && e.detail && e.detail.analyticsAllowed) loadAmplitude();
    else if (hasAnalyticsConsent()) loadAmplitude();
  });
  if (window.Shopify && window.Shopify.customerPrivacy) {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
